import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingSeedance25AiVideoGeneratorConfig } from '@/data/landingConfig/landingSeedance25AiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Seedance25AiVideoGenerator } from './schemaObject';

interface Props {}
const Seedance25AiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Seedance25AiVideoGenerator} />
			<LandingTemplate
				data={landingSeedance25AiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default Seedance25AiVideoGenerator;
